module.exports = __webpack_public_path__ + "static/media/exhibition-services-img8.0f62fbe3.jpg";